import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "「スピードが上がらない」「トップとミドルの意識ギャップが埋まらない」大企業DX推進の典型的な課題に、i3DESIGNは2019年からDesignSprintワークショップや戦略策定で伴走。総合化学メーカー・カネカPFSV事業部の自己変革を長期支援した製造業DX推進事例です。"

const primaryImage = "https://www.i3design.jp/ogp_logo.png"

export const kanekaPageMeta: PageMeta = {
  title: "カネカ 製造業の大企業DX推進を5年以上伴走｜DesignSprintで組織変革を支援した事例 | i3DESIGN",
  description,
  keyword: "DX戦略 組織開発 人材育成 生成AI デジタルトランスフォーメーション",
  image: primaryImage,
  url: `${SITE_URL}/cases/kaneka/`,
}

export const kanekaSchema = buildCaseStudySchema({
  slug: "kaneka",
  pageTitle: kanekaPageMeta.title,
  description: kanekaPageMeta.description,
  headline: "変化し続ける市場の最先端を走るために必須なDX推進を支援",
  alternativeHeadline: "株式会社カネカ",
  primaryImage,
  images: ["https://www.i3design.jp/ogp_logo.png","https://www.i3design.jp/images/img/cases/kaneka/top.png"],
  clientName: "株式会社カネカ",
  breadcrumbLabel: "変化し続ける市場の最先端を走るために必須なDX推進を支援",
})
